import React, { useEffect, useState, useRef } from "react";
import EditProfile from "./EditProfile";
import ReferAndEarn from "./ReferAndEarn";
import { logout } from "../../redux/actions/userActions";
import { useDispatch } from "react-redux";
import { USER_EVENTS_EMPTY } from "../../redux/constants/userConstants";
import { EVENT_CREATE_DESTROY } from "../../redux/constants/eventConstants";
import ScanIcon from "../../common/scanIcon/ScanIcon";
import DefaultProfilePicture from "../../common/defaultProfilePicture/DefaultProfilePicture";
import { useNavigate } from "react-router-dom";

function AccountPanel({ savedUserConfig }) {
  const [showProfile, setShowProfile] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ref = useRef(null);

  return (
    <>
      {showProfile === true && (
        <div
          className={`max-w-[1440px] px-[16px] w-full mx-auto min-h-[calc(100vh-58px)] md:w-[422px]`}
        >
          <div className="w-full h-[570px] pt-10">
            <div className="grid place-items-center">
              {savedUserConfig?.profilePicture ? (
                <img
                  src={savedUserConfig.profilePicture}
                  alt="User"
                  className="h-[100px] w-[100px] rounded-[50%] my-auto object-cover"
                />
              ) : (
                <DefaultProfilePicture
                  firstName={savedUserConfig?.firstName}
                  lastName={savedUserConfig?.lastName}
                  style={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "100%",
                    fontSize: "27px",
                  }}
                />
              )}
            </div>
            <p className="text-black text-opacity-50 pt-5 text-center">
              {savedUserConfig?.email}
            </p>
            <div className="mt-5">
              <hr />
            </div>

            <div className="flex items-center w-full md:w-[387px] h-[50px] mt-5">
              {savedUserConfig?.profilePicture ? (
                <img
                  src={savedUserConfig.profilePicture}
                  alt="User"
                  className="h-[60px] w-[60px] rounded-[50%] my-auto object-cover"
                />
              ) : (
                <DefaultProfilePicture
                  firstName={savedUserConfig?.firstName}
                  lastName={savedUserConfig?.lastName}
                  style={{
                    height: "64px",
                    width: "64px",
                    borderRadius: "32px",
                  }}
                />
              )}
              <div className="ml-5 w-full md:w-[259px] text-[14px]">
                <p className="font-semibold text-[17px] ">{`${savedUserConfig?.firstName} ${savedUserConfig?.lastName}`}</p>
                <p className="text-black text-opacity-50 mt-[0px]">
                  {savedUserConfig?.organization}
                </p>
              </div>
              <img
                src="/svgs/Edit.svg"
                alt="edit"
                className="h-[23px] w-[23px] md:h-[18px] md:w-[18px] cursor-pointer relative -left-[25px] md:static"
                onClick={() => setShowProfile("editProfile")}
              />
            </div>
            <div className="mt-5">
              <hr />
            </div>

            <div className="mx-auto my-0">
              <div
                className={`cursor-pointer w-[140px] bg-danger text-[16px] grid place-items-center h-[40px] rounded-[8px] text-[#fff] font-[600] mt-[30px] mx-auto`}
                onClick={() => {
                  let linkedinAccessToken = localStorage.getItem(
                    "linkedinAccessToken"
                  );
                  localStorage.clear();
                  if (linkedinAccessToken) {
                    localStorage.setItem(
                      "linkedinAccessToken",
                      linkedinAccessToken
                    );
                  }
                  dispatch({
                    type: USER_EVENTS_EMPTY,
                    payload: [],
                  });
                  dispatch({
                    type: EVENT_CREATE_DESTROY,
                  });
                  dispatch(logout());

                  // navigate("/login");
                }}
              >
                Logout
              </div>
            </div>
          </div>
        </div>
      )}
      <ScanIcon />

      {showProfile === "editProfile" && (
        <EditProfile
          setShowProfile={setShowProfile}
          savedUserConfig={savedUserConfig}
        />
      )}
      {showProfile === "referAndEarn" && (
        <ReferAndEarn setShowProfile={setShowProfile} />
      )}
    </>
  );
}

export default AccountPanel;
